import profileValidator from '../../../../../models/profile/validators'
import workoutValidator from '../../../../../modules/workout/model/validators'
import { POST_CLASS_NAME } from '../../../../post/model/constants'
import { PROFILE_CLASS_NAME } from '../../../../../models/profile/constants'
import emailValidatorUtil from './email'
import passwordValidatorUtil from './password'
import urlValidatorUtil from './url'
import { WORKOUT_CLASS_NAME } from '../../../../workout'
import { postValidator } from '../../../../post'
import { EXERCISE_LOG_SUMMARY_CLASS_NAME } from '../../../../exercise-log-summary/model/constants'
import exerciseLogSummaryValidator from '../../../../exercise-log-summary/model/validators'

const KEY_TO_GENERIC_VALIDATOR = {
  url: urlValidatorUtil,
  email: emailValidatorUtil,
  password: passwordValidatorUtil
}

const CLASS_NAME_TO_VALIDATOR = {
  [EXERCISE_LOG_SUMMARY_CLASS_NAME]: exerciseLogSummaryValidator,
  [POST_CLASS_NAME]: postValidator,
  [PROFILE_CLASS_NAME]: profileValidator,
  [WORKOUT_CLASS_NAME]: workoutValidator
}

function validatorUtil (params) {
  const {
    key,
    className
  } = params
  const validator = CLASS_NAME_TO_VALIDATOR[className]
  if (validator && validator[key]) {
    return validator[key]
  }
  return KEY_TO_GENERIC_VALIDATOR[key]
}

export default validatorUtil
